export const SET_HRES6ME_INDEX_DISP = 'SET_HRES6ME_INDEX_DISP'
export const GET_HRES6ME_INDEX_DISP = 'GET_HRES6ME_INDEX_DISP'
export const SET_HRES6ME_DETAIL_DISP = 'SET_HRES6ME_DETAIL_DISP'
export const GET_HRES6ME_DETAIL_DISP = 'GET_HRES6ME_DETAIL_DISP'
export const SET_HRES6ME_COLUMNS = 'SET_HRES6ME_COLUMNS'
export const GET_HRES6ME_COLUMNS = 'GET_HRES6ME_COLUMNS'
export const SET_HRES6ME_LABELS = 'SET_HRES6ME_LABELS'
export const GET_HRES6ME_LABELS = 'GET_HRES6ME_LABELS'
export const RECEIVED_HRES6ME_COLUMNS_LABELS = 'RECEIVED_HRES6ME_COLUMNS_LABELS'
export const SET_HRES6ME_INDEX = 'SET_HRES6ME_INDEX'
export const GET_HRES6ME_INDEX = 'GET_HRES6ME_INDEX'
export const SET_HRES6ME_INDEX_SELECTED = 'SET_HRES6ME_INDEX_SELECTED'
export const GET_HRES6ME_INDEX_SELECTED = 'GET_HRES6ME_INDEX_SELECTED'
export const RECEIVED_HRES6ME_INDEX = 'RECEIVED_HRES6ME_INDEX'
export const SET_HRES6ME_DETAIL = 'SET_HRES6ME_DETAIL'
export const GET_HRES6ME_DETAIL = 'GET_HRES6ME_DETAIL'
export const RECEIVED_HRES6ME_DETAIL = 'RECEIVED_HRES6ME_DETAIL'
export const TOGGLE_HRES6ME_PAGE = 'TOGGLE_HRES6ME_PAGE'
export const POST_HRES6ME_SAVE_CANCEL = 'POST_HRES6ME_SAVE_CANCEL'



// WEBPACK FOOTER //
// ./src/store/modules/hres6me/mutation-types.js